// SPDX-License-Identifier: AGPL-3.0-or-later
// Rewrite product copy, leaving IDs, interpolation values and external instances intact.
function brandValue(value) {
  if (typeof value === 'string') return value.replace(/\bFlux(?:er|ur)(?=\b|Tag)/g, 'Raven');
  if (Array.isArray(value)) return value.map(brandValue);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, brandValue(child)]));
  }
  return value;
}
export function catalogWithRavenBranding(messages, englishMessages = messages) {
  const externalIds = new Set(Object.entries(englishMessages)
    .filter(([, value]) => /official Fluxer instance|Fluxer Platform AB/.test(JSON.stringify(value)))
    .map(([id]) => id));
  return Object.fromEntries(Object.entries(messages)
    .map(([id, value]) => [id, externalIds.has(id) ? value : brandValue(value)]));
}
